import React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { overlayOpenEditorDraftNew } from 'shared/actions/view/web';
import { compose } from 'shared/helpers';
import { BASE_COLOR } from 'shared/constants/colors';
import typewriterMdImage from 'shared/static/images/typewriter-md.jpg';
import { classes } from 'shared/styles';

import { mixClasses as cx } from 'helpers';
import { TinyLetterForm } from 'components/forms';
import { Link, Input } from 'components/elems';
import { RectButton, SvgIcon } from 'components/elems';


const VerticallyCentered = ({ children, className }) => (
  <div className="h-100 flex flex-column justify-center">
    <div>
      <div className={cx("center", className)}>
        {children}
      </div>
    </div>
  </div>
);

const LeftHalf = ({ children }) => (
  <div className='w-100 w-75-m w-50-l flex flex-column justify-between ph3 ph4-ns'>
    {children}
  </div>
);

const RightHalf = ({ children }) => (
  <div className='dn w-50-l db-l ph3 tc'>
    {children}
  </div>
);


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    overlayOpenEditorDraftNew,
  }, dispatch);
};


/*
 * HomeExternal page
 */
class HomeExternal extends React.Component {
  openBlogComposer = () => {
    // XXX: Hardcode the module id of latest blog composer.
    const moduleId = 'web.moagraph.note.1';
    this.props.overlayOpenEditorDraftNew({ moduleId });
  }

  render() {
    const { classes: cn } = this.props;
    const articleUrl = "https://stratechery.com/2017/the-faceless-publisher/";

    return (
      <div className='vh-100'>
        <VerticallyCentered className="mw8">

          <div className="flex">
            <LeftHalf>
              {/* top blank element for flex spacing */}
              <div />

              {/* middle */}
              <div>
                <div className={cx(cn.moagraph, 'moa-ff-argent dark-gray f2 f1-ns')}>
                  <span className="relative">Moagraph</span>
                </div>
                <div className="moa-ff-sans mt2 f6 f5-ns">
                  /ˈmōəˌɡraf/
                </div>
                <div className="moa-ff-sans mt4 f6 f5-ns lh-copy black-70">
                  <p>
                    Moagraph is a work-in-progress project with a goal of building
                    a "<Link type="accented" href={articleUrl}>faceless publisher</Link>" that
                    makes creating and publishing to own audience as easy as messaging.
                  </p>
                  <p>
                    The first step is in active development to build a range of modularized CMS tools.
                    Still a long way to go, but you can preview the document module for short-form writing:
                  </p>
                </div>

                <RectButton
                  className={classes.boxShadowRaisedButton}
                  label="WRITE"
                  icon={<SvgIcon.im.Quill />}
                  style={{ fontSize: '12px' }}
                  onClick={this.openBlogComposer}
                  theme="primary"
                />

                <TinyLetterForm list="moagraph" className="mt4">
                  <Input
                    type="email"
                    wrapStyle={{
                      width: 'calc(100% - 48px)',
                      marginBottom: 0,
                    }}
                    placeholder="Subscribe to mailing list for updates"
                  />
                  <input
                    className={cx("-button glow o-30 mid-gray fr")}
                    style={{
                      marginTop: '-50px',
                      width: '24px',
                      height: '24px',
                    }}
                    type="submit"
                    value="⤅"
                  />
                </TinyLetterForm>
              </div>


              {/* bottom, for flexbox spacing */}
              <div />
            </LeftHalf>

            <RightHalf>
              <img
                className={cx(cn.typewriterMdImage, "ph3")}
                src={typewriterMdImage}
                alt="vintage typewriter"
              />
            </RightHalf>
          </div>

        </VerticallyCentered>
      </div>
    );
  }
}


const styles = {
  moagraph: {
    '& > span:after': {
      content: '"ALPHA"',
      fontSize: '9px',
      position: 'absolute',
      top: '8px',
      color: BASE_COLOR.lightSilver,
      fontFamily: "'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    },
  },
  typewriterMdImage: {
    maxWidth: '448px',
    opacity: '0',
    animation: 'opacityFadeInFull 600ms ease-in-out 600ms 1 forwards',
  },
};


export default compose(
  connect(null, mapDispatchToProps),
  injectSheet(styles),
)(HomeExternal);



// WEBPACK FOOTER //
// ./src/pages/_home/HomeExternal.js